export default __webpack_public_path__ + "static/media/plan_etaj.e939e91f.jpeg";